export const validateCpfCnpj = (val: string): boolean => {
  if (!val) return true; // Optional field, if empty it's valid. Change to false if it's required.

  const cleanVal = val.replace(/\D/g, '');
  if (cleanVal.length === 11) {
    return validateCpf(cleanVal);
  } else if (cleanVal.length === 14) {
    return validateCnpj(cleanVal);
  }
  return false;
};

const validateCpf = (cpf: string): boolean => {
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(cpf.charAt(i)) * (10 - i);
  let rest = 11 - (sum % 11);
  let digit = rest > 9 ? 0 : rest;
  if (parseInt(cpf.charAt(9)) !== digit) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(cpf.charAt(i)) * (11 - i);
  rest = 11 - (sum % 11);
  digit = rest > 9 ? 0 : rest;
  return parseInt(cpf.charAt(10)) === digit;
};

const validateCnpj = (cnpj: string): boolean => {
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  let size = cnpj.length - 2;
  let numbers = cnpj.substring(0, size);
  const digits = cnpj.substring(size);
  let sum = 0;
  let pos = size - 7;
  for (let i = size; i >= 1; i--) {
    sum += parseInt(numbers.charAt(size - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(0))) return false;

  size += 1;
  numbers = cnpj.substring(0, size);
  sum = 0;
  pos = size - 7;
  for (let i = size; i >= 1; i--) {
    sum += parseInt(numbers.charAt(size - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  return result === parseInt(digits.charAt(1));
};
